import { render, staticRenderFns } from "./OnBoardingCustomer.vue?vue&type=template&id=7da1ea02"
import script from "./OnBoardingCustomer.vue?vue&type=script&lang=js"
export * from "./OnBoardingCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports